import { Platform } from 'react-native'

import ArrowRightIcon from 'app/assets/icons/arrow-right.svg'
import Button, { ButtonProps } from 'app/components/base/Button'

const NavigationSlideButton: RFC<{
  disabled?: boolean
  rotate?: boolean
  onClick?: () => void
}> = ({ disabled, rotate, onClick }) => {
  return (
    <Button
      variant="outlined"
      disabled={disabled}
      aria-label="image-navigation-arrow"
      sx={
        {
          height: 36,
          width: 36,
          minWidth: 36,
          minHeight: 36,
          p: 0,
          ...Platform.select({
            web: {
              display: { md: 'block', xs: 'none' },
              ...(rotate && { transform: 'rotate(180deg)' })
            },
            native: {
              transform: [{ scale: 0 }]
            }
          })
        } as ButtonProps['sx']
      }
      onClick={onClick}
    >
      <ArrowRightIcon />
    </Button>
  )
}

export default NavigationSlideButton
